import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function Products() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [form, setForm] = useState({
    name: '',
    category_id: '',
    price: '',
    description: ''
  });
  

  const navigate = useNavigate();

  useEffect(() => {
    fetchProducts();
    fetchCategories();
  }, []);

  const fetchProducts = async () => {
    
  try {
    const res = await axios.get('https://xcelitsolutions.co.uk/get_products.php');
    console.log('PRODUCTS RESPONSE:', res.data); // <--- Add this
    setProducts(Array.isArray(res.data) ? res.data : []);
  } catch (err) {
    console.error('Fetch products error:', err);
    setProducts([]);
  }
};

  const fetchCategories = async () => {
    const res = await axios.get('https://xcelitsolutions.co.uk/get_categories.php');
    setCategories(res.data);
  };

  const handleOpenDialog = (product = null) => {
    setSelectedProduct(product);
    if (product) {
      setForm({
        name: product.name,
        category_id: product.category_id,
        price: product.price,
        description: product.description
      });
    } else {
      setForm({
        name: '',
        category_id: '',
        price: '',
        description: ''
      });
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedProduct(null);
    setForm({
      name: '',
      category_id: '',
      price: '',
      description: ''
    });
  };

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async () => {
    const data = new URLSearchParams(form);
    try {
      if (selectedProduct) {
        // UPDATE
        data.append('id', selectedProduct.id);
        await axios.post('https://xcelitsolutions.co.uk/update_product.php', data);
      } else {
        // ADD
        await axios.post('https://xcelitsolutions.co.uk/add_product.php', data);
      }
      fetchProducts();
      handleCloseDialog();
    } catch (err) {
      console.error('Error saving product:', err);
    }
  };

  const handleDelete = async () => {
    if (selectedProduct?.id) {
      await axios.post('https://xcelitsolutions.co.uk/api/delete_product.php', new URLSearchParams({ id: selectedProduct.id }));
      fetchProducts();
      handleCloseDialog();
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Products</h2>
      <Button variant="contained" onClick={() => handleOpenDialog()}>Add Product</Button>
      <Button variant="outlined" onClick={() => navigate('/categories')} style={{ marginLeft: 10 }}>View and add Categories</Button>

      {/* <ul>
        {products.map(p => (
          <li key={p.id} onClick={() => handleOpenDialog(p)} style={{ cursor: 'pointer' }}>
            <b>{p.name}</b> - {p.category} - ${p.price}<br />
            {p.description}
          </li>
        ))}
      </ul> */}

      <TableContainer component={Paper} style={{ marginTop: 20 }}>
  <Table>
    <TableHead>
      <TableRow>
        <TableCell><strong>Name</strong></TableCell>
        <TableCell><strong>Category</strong></TableCell>
        <TableCell><strong>Price</strong></TableCell>
        <TableCell><strong>Description</strong></TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {Array.isArray(products) && products.map((p) => (
        <TableRow key={p.id} onClick={() => handleOpenDialog(p)} style={{ cursor: 'pointer' }}>
          <TableCell>{p.name}</TableCell>
          <TableCell>{p.category}</TableCell>
          <TableCell>${parseFloat(p.price).toFixed(2)}</TableCell>
          <TableCell>{p.description}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
</TableContainer>


      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>{selectedProduct ? 'Update Product' : 'Add Product'}</DialogTitle>
        <DialogContent>
          <TextField
            name="name"
            label="Name"
            fullWidth
            margin="dense"
            value={form.name}
            onChange={handleChange}
          />
          <TextField
            name="category_id"
            label="Category"
            select
            fullWidth
            margin="dense"
            value={form.category_id}
            onChange={handleChange}
          >
            {categories.map(cat => (
              <MenuItem key={cat.id} value={cat.id}>{cat.name}</MenuItem>
            ))}
          </TextField>
          <TextField
            name="price"
            label="Price"
            type="number"
            fullWidth
            margin="dense"
            value={form.price}
            onChange={handleChange}
          />
          <TextField
            name="description"
            label="Description"
            fullWidth
            multiline
            rows={3}
            margin="dense"
            value={form.description}
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions>
          {selectedProduct && (
            <Button color="error" onClick={handleDelete}>Delete</Button>
          )}
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleSubmit}>Save</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
